module.exports = __webpack_public_path__ + "static/media/JunctionX_logos-wordmark-white.2aad815e.svg";